import { useId } from "react";

import { cn } from "@/lib/utils";

export default function KnightHeroIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[812px] w-[375px]", className)}
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 375 812"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}-a)`}>
        <path d="M0 0h375v812H0z" fill="#fff" />
        <path d="M-1601.5 0H4450v737.145h-6051.5z" fill={`url(#${id}-b)`} />
        <g filter={`url(#${id}-c)`}>
          <ellipse
            cx="-399.65"
            cy="305.799"
            fill="#31C7ED"
            rx="588.137"
            ry="590.185"
          />
        </g>
        <g filter={`url(#${id}-d)`}>
          <ellipse
            cx="796.894"
            cy="420.457"
            fill="#3E2AA3"
            rx="706.417"
            ry="689.108"
          />
        </g>
        <path
          d="M515.434 373.608a4.856 4.856 0 109.712 0 4.856 4.856 0 00-9.712 0z"
          fill={`url(#${id}-e)`}
        />
        <path
          d="M404.531 397.108a4.012 4.012 0 108.023 0 4.012 4.012 0 00-8.023 0z"
          fill={`url(#${id}-f)`}
        />
        <path
          d="M552.275 335.509a2.832 2.832 0 105.664 0 2.832 2.832 0 00-5.664 0z"
          fill={`url(#${id}-g)`}
        />
        <path
          d="M354.496 299.871a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-h)`}
        />
        <path
          d="M282.543 255.604a4.248 4.248 0 108.496 0 4.248 4.248 0 00-8.496 0z"
          fill={`url(#${id}-i)`}
        />
        <path
          d="M313.17 151.184a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-j)`}
        />
        <path
          d="M424.549 107.714a2.36 2.36 0 104.72 0 2.36 2.36 0 00-4.72 0z"
          fill={`url(#${id}-k)`}
        />
        <path
          d="M299.935 66.411a3.068 3.068 0 106.135.001 3.068 3.068 0 00-6.135 0z"
          fill={`url(#${id}-l)`}
        />
        <path
          d="M489.023 209.522a2.597 2.597 0 105.194-.002 2.597 2.597 0 00-5.194.002z"
          fill={`url(#${id}-m)`}
        />
        <path
          d="M593.275 149.273a3.282 3.282 0 106.564 0 3.282 3.282 0 00-6.564 0z"
          fill={`url(#${id}-n)`}
        />
        <path
          d="M490.681 149.02a3.535 3.535 0 107.07 0 3.535 3.535 0 00-7.07 0z"
          fill={`url(#${id}-o)`}
        />
        <path
          d="M255.4 400.781a3.668 3.668 0 107.335.001 3.668 3.668 0 00-7.335-.001z"
          fill={`url(#${id}-p)`}
        />
        <path
          d="M197.847 191.52a3.283 3.283 0 106.567.001 3.283 3.283 0 00-6.567-.001z"
          fill={`url(#${id}-q)`}
        />
        <path
          d="M167.703 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-r)`}
        />
        <path
          d="M140.387 445.626a5.952 5.952 0 1011.905 0 5.952 5.952 0 00-11.905 0z"
          fill={`url(#${id}-s)`}
        />
        <path
          d="M1084.11 373.608a4.86 4.86 0 009.72 0 4.861 4.861 0 00-4.86-4.857 4.861 4.861 0 00-4.86 4.857z"
          fill={`url(#${id}-t)`}
        />
        <path
          d="M973.21 397.108a4.012 4.012 0 108.023 0 4.012 4.012 0 00-8.023 0z"
          fill={`url(#${id}-u)`}
        />
        <path
          d="M1120.95 335.509a2.835 2.835 0 005.67 0 2.835 2.835 0 00-5.67 0z"
          fill={`url(#${id}-v)`}
        />
        <path
          d="M923.175 299.871a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-w)`}
        />
        <path
          d="M851.222 255.604a4.248 4.248 0 108.497 0 4.248 4.248 0 00-8.497 0z"
          fill={`url(#${id}-x)`}
        />
        <path
          d="M859.644 183.753a4.485 4.485 0 108.97-.002 4.485 4.485 0 00-8.97.002z"
          fill={`url(#${id}-y)`}
        />
        <path
          d="M930.255 151.184a3.541 3.541 0 107.082-.002 3.541 3.541 0 00-7.082.002z"
          fill={`url(#${id}-z)`}
        />
        <path
          d="M968.962 238.992a4.13 4.13 0 108.26 0 4.13 4.13 0 00-8.26 0z"
          fill={`url(#${id}-A)`}
        />
        <path
          d="M993.228 107.714a2.36 2.36 0 104.72 0 2.36 2.36 0 00-4.72 0z"
          fill={`url(#${id}-B)`}
        />
        <path
          d="M795.298 149.059a3.069 3.069 0 106.137-.001 3.069 3.069 0 00-6.137.001z"
          fill={`url(#${id}-C)`}
        />
        <path
          d="M1057.7 209.522a2.596 2.596 0 105.192 0 2.596 2.596 0 00-5.192 0z"
          fill={`url(#${id}-D)`}
        />
        <path
          d="M1161.95 149.273a3.284 3.284 0 006.57 0 3.282 3.282 0 00-3.28-3.282 3.284 3.284 0 00-3.29 3.282z"
          fill={`url(#${id}-E)`}
        />
        <path
          d="M1123.58 15.732a3.532 3.532 0 003.53 3.534 3.534 3.534 0 100-7.069 3.532 3.532 0 00-3.53 3.535z"
          fill={`url(#${id}-F)`}
        />
        <path
          d="M824.079 400.781a3.668 3.668 0 107.335.001 3.668 3.668 0 00-7.335-.001z"
          fill={`url(#${id}-G)`}
        />
        <path
          d="M766.526 191.52a3.283 3.283 0 106.567.001 3.283 3.283 0 00-6.567-.001z"
          fill={`url(#${id}-H)`}
        />
        <path
          d="M684.943 267.397a3.444 3.444 0 106.888 0 3.444 3.444 0 00-6.888 0z"
          fill={`url(#${id}-I)`}
        />
        <path
          d="M659.067 161.655a2.513 2.513 0 105.025 0 2.513 2.513 0 00-5.025 0z"
          fill={`url(#${id}-J)`}
        />
        <path
          d="M736.382 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-K)`}
        />
        <path
          d="M709.066 445.626a5.952 5.952 0 1011.905 0 5.952 5.952 0 00-11.905 0z"
          fill={`url(#${id}-L)`}
        />
        <path
          d="M-305.301 647.704H697.101L297.693 211.672l-48.018 16.918-80.081 72.573-85.396 9.963-389.499 336.578z"
          fill={`url(#${id}-M)`}
        />
        <path
          clipRule="evenodd"
          d="M-344.729 222.944l81.626.234 651.528 1.893 130.603.38 265.754.771 64.194.185 36.178.108 137.716.39 52.3.156c-13.15-2.732-26.12-4.829-38.77-6.41-73.992-9.248-136.699-.741-157.718 2.8-4.898.83-7.55 1.386-7.55 1.386s-2.537-3.093-9.533-6.517c-5.656-2.81-14.314-5.834-26.937-7.581-21.194-2.936-42.854-.048-55.885 2.449-7.551 1.454-12.186 2.781-12.186 2.781s1.836-4.215 2.711-9.278c1.108-6.449.612-14.293-7.317-16.576-14.11-4.068-32.272 0-32.272 0s-24.226-28.79-82.764-33.18c-55.973-4.185-100.867 3.649-104.686 4.351-.175.02-.263.039-.263.039-.262-.224-.524-.458-.787-.683a85.58 85.58 0 00-4.256-3.483c0-.019-.058-.048-.087-.068a115.214 115.214 0 00-12.128-8.146c-25.537-14.946-51.989-31.146-113.384-27.381-83.434 5.113-108.378 45.781-108.378 45.781-95.037-13.971-168.706 11.502-168.706 11.502s-38.335-4.654-74.688 4.663c-19.474 4.986-26.762 13.668-29.328 20.664-.816 2.185-1.166 4.214-1.253 5.902-1.079-1.385-3.294-2.781-7.521-3.776a2.711 2.711 0 00-.234-.058c-12.127-2.742-32.3-1.093-32.3-1.093v-.019c-26.305-44.095-95.37-44.76-115.632-45.134-56.76-1.054-82.868 22.548-122.369 38.363-14.401 5.756-25.392 10.722-31.368 13.522-3.353 1.551-5.131 2.439-5.131 2.439-28.307-8.907-59.179 8.624-59.179 8.624z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.3"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          clipRule="evenodd"
          d="M-578.618 681.116c45.862 43.868-167.817 125.58-266.686 153.829l63.531 6.061 1426.18 4.332 22.267-128.981C203.44 584.422-231.313 576.172-231.313 576.172l-37.994-.451h-694.711c-14.462.524-37.892.907-65.802 1.362-50.36.822-115.27 1.882-168.28 4.44-18.07 2.83-25.74 5.512-16.23 7.75 11.45 2.693 56.9 5.932 118.29 10.306 165.861 11.818 475.58 41.514 517.422 81.537z"
          fill="#48A3CD"
          fillRule="evenodd"
        />
        <path
          d="M180.591 535.006c-33.109-11.5-32.964 14.306-28.753 28.646 120.718 12.321 237.416 3.618 280.675-2.274-.929-16.646-14.46-18.074-21.109-16.707 8.6-34.189-17.953-54.782-41.573-18.269-3.777-10.204-15.007-8.545-20.149-6.44-.992-52.876-44.074-49.208-48.059-10.165-13.167-9.76-24.024-2.452-27.806 2.422-9.419-13.585-28.451-12.722-34.747 5.1-23.214-45.205-54.419-22.09-43.819 5.412-12.868-2.124-15.135 7.298-14.66 12.275z"
          fill="#209F99"
        />
        <path
          d="M268.304 536.264c-1.318-7.397-5.194-21.272-10.153-17.602-4.959 3.67 4.703 13.264 10.153 17.602z"
          fill="#209F99"
        />
        <path
          clipRule="evenodd"
          d="M359.343 568.19c.194-19.026-15.783-27.433-30.987-4.181-2.525-7.676-10.63-6.571-14.367-5.059.274-39.549-30.771-37.328-34.365-8.183-9.285-7.457-17.228-2.125-20.038 1.474-6.519-10.272-20.22-9.857-25.079 3.392-15.847-34.082-38.715-17.176-31.607 3.516-8.428-1.596-10.657 4.14-10.785 7.983 65.562 5.226 126.589 3.797 167.228 1.058zm-171.321-1.393c-3.593-.975-6.531-1.174-8.916-.786 2.979.276 5.952.538 8.916.786z"
          fill="#209F99"
          fillRule="evenodd"
        />
        <path
          d="M1059.6 551.136c-353.392-38.88-1091.877-7.447-1121.807 23.392l864.884 401.614C1725.84 813.659 1412.99 590.015 1059.6 551.136z"
          fill="#4E4288"
        />
        <path
          clipRule="evenodd"
          d="M935.039 555.874l-40.611.147-324.151 1.189-64.978.239-132.219.484-31.938.117-17.999.067-68.517.245-26.02.098a196.956 196.956 0 0119.29-4.027c36.811-5.81 68.009-.466 78.467 1.759 2.436.521 3.756.871 3.756.871s1.262-1.943 4.743-4.095c2.814-1.765 7.122-3.665 13.402-4.762 10.544-1.845 21.321-.031 27.804 1.538 3.757.914 6.063 1.747 6.063 1.747s-.914-2.648-1.349-5.829c-.551-4.051-.305-8.979 3.64-10.414 7.02-2.556 16.056 0 16.056 0s12.053-18.087 41.177-20.846c27.848-2.629 50.184 2.293 52.084 2.734a.994.994 0 01.131.025c.13-.141.261-.288.391-.429a46.876 46.876 0 012.118-2.189c0-.012.029-.03.044-.043a58.776 58.776 0 016.033-5.118c12.706-9.39 33.171-16.96 63.716-14.594 41.511 3.212 46.616 26.154 46.616 26.154 47.284-8.777 83.935 7.227 83.935 7.227s19.073-2.924 37.16 2.93c9.688 3.132 13.314 8.587 14.591 12.982.406 1.373.58 2.648.623 3.708.537-.87 1.639-1.747 3.742-2.372.029-.012.073-.025.116-.037 6.034-1.722 16.071-.686 16.071-.686v-.013c-.058-.263-.928-4.456.783-9.476 2.596-7.6 11.11-17.088 37.377-17.701 28.239-.662 60.598 12.988 80.251 22.924 7.165 3.616 12.633 6.736 15.606 8.495 1.668.975 2.553 1.532 2.553 1.532 14.083-5.596 29.443 5.419 29.443 5.419z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path d="M-93.333 448.629H78.819v107.426H-93.333z" fill="#9E5227" />
        <path
          d="M31.065 376.039v81.764l13.05 10.438 13.049-10.438v-81.764H31.065z"
          fill={`url(#${id}-N)`}
        />
        <path
          d="M31.065 376.039v81.764l13.05 10.438 13.049-10.438v-81.764H31.065z"
          fill={`url(#${id}-O)`}
        />
        <path
          d="M38.792 408.936a5.377 5.377 0 1110.756 0v17.653H38.792v-17.653z"
          fill="#4D0D54"
        />
        <path
          d="M44.147 313.832l15.038 61.699H29.108l15.039-61.699z"
          fill={`url(#${id}-P)`}
        />
        <path
          d="M44.147 313.832l15.038 61.699H29.108l15.039-61.699z"
          fill={`url(#${id}-Q)`}
        />
        <path
          d="M31.07 388.996l-4.051-8.108h34.303l-4.052 8.108h-26.2z"
          fill="#944C1D"
        />
        <path
          clipRule="evenodd"
          d="M38.697 370.169v4.067h3.421v-4.067h4.106v4.067h3.42v-4.067h4.106v4.067h3.42v-4.067h4.152v10.723H27.019v-10.723h4.152v4.067h3.421v-4.067h4.105z"
          fill="#D5815D"
          fillRule="evenodd"
        />
        <path d="M26.215 440.548h35.799v8.08H26.215z" fill="#CCDAFF" />
        <path d="M-37.746 359.475h60.977v30.651h-60.977z" fill="#4D0D54" />
        <path
          d="M-49.148 388.737h83.783v50.219h-83.783z"
          fill={`url(#${id}-R)`}
        />
        <path
          d="M-49.148 388.996h83.783v165.671h-83.783z"
          fill={`url(#${id}-S)`}
        />
        <path d="M-53.195 380.393h91.876v9.732h-91.876z" fill="#fff" />
        <path
          d="M76.752 414.563v140.104h44.72V414.563h-44.72z"
          fill={`url(#${id}-T)`}
        />
        <path
          d="M76.752 414.563v140.104h44.72V414.563h-44.72z"
          fill={`url(#${id}-U)`}
        />
        <path
          d="M101.418 448.629h10.043v5.312h-10.043zm0 21.597h10.043v5.312h-10.043z"
          fill="#C67E49"
        />
        <path d="M106.737 453.94h10.043v5.312h-10.043z" fill="#C67E49" />
        <path
          d="M86.108 451.581a4.308 4.308 0 118.615 0v14.14h-8.615v-14.14z"
          fill="#4D0D54"
        />
        <path d="M99.14 413.457v-114.76" stroke="#fff" strokeWidth="2.091" />
        <path
          d="M86.108 489.076a4.308 4.308 0 118.615 0v14.14h-8.615v-14.14zm0 43.049a4.307 4.307 0 118.615.001v14.14h-8.615v-14.141z"
          fill="#4D0D54"
        />
        <path
          d="M99.135 352.512l27.806 61.181H71.329l27.806-61.181z"
          fill={`url(#${id}-V)`}
        />
        <path
          d="M99.135 352.512l27.806 61.181H71.329l27.806-61.181z"
          fill={`url(#${id}-W)`}
        />
        <path
          d="M126.295 404.721c-.117-.86 2.136-6.592 4.242-11.849l2.079 1.183-4.502 9.899 1.65 1.403-1.236 1.661c-.024-.263-.087-.838-.141-1.043-.054-.205-1.417-.922-2.092-1.254z"
          fill={`url(#${id}-X)`}
        />
        <path
          d="M137.006 388.821c-.403 1.342-2.796-2.224-3.942-2.475-2.181 1.593-.692 7.976 1.069 7.725 1.409-.202 3.087-2.924 3.814-2.477.168-3.606-.539-4.115-.941-2.773zm6.969-6.014l.397 1.215c.084-1.389-.427-3.662-3.139-1.644-3.391 2.522-2.908 9.014.234 8.559 2.514-.364 2.853-5.897 2.508-8.13z"
          fill="#F3898A"
        />
        <path
          clipRule="evenodd"
          d="M140.058 379.007c2.167-.758 4.982-1.356 5.819-.472 1.274 1.345-.649 4.572-1.77 6.018-.401-.727-1.497-1.183-2.624-.788.409 2.051.9 4.342 1.43 6.811 1.364 6.359 2.983 13.904 4.109 21.595 1.657 11.323 2.285 23.17-.566 32.339-2.388 7.678-5.54 13.149-8.556 18.384-.554.961-1.103 1.914-1.642 2.872-2.128 3.781-4.118 7.657-5.662 12.415-1.918 12.99.161 25.368 2.011 36.391 1.512 9.003 2.871 17.102 1.778 23.891-2.389 14.825 4.655 20.927 8.476 24.13-5.148-.572-16.816-4.53-22.307-15.786-6.863-14.069-6.878-41.027-2.058-71.378 3.932-24.767 7.077-31.945 11.112-41.151v-.001c.909-2.075 1.864-4.255 2.883-6.762 5.54-13.626 2.817-34.101 1.894-37.91-.924-3.809-1.085-8.496.923-10.157 1.669-1.38 3.38-1.104 4.75-.441zm-4.75 82.832c10.118-22.792 10.305-43.538 8.653-58.07a218.476 218.476 0 011.455 8.637c1.652 11.288 2.226 22.824-.51 31.622-2.33 7.493-5.387 12.801-8.398 18.031a343.14 343.14 0 00-1.664 2.91 102.89 102.89 0 00-2.247 4.187 61.825 61.825 0 012.711-7.317z"
          fill={`url(#${id}-Y)`}
          fillRule="evenodd"
        />
        <path
          d="M133.55 391.994c-.22-1.056.506-4.267 0-5.5-4.07-2.2-3.685 1.265-4.895 2.75-.968 1.188-3.575 2.108-4.951 2.53-.989-.623-3.871-1.452-7.48.22-3.608 1.672-12.991 23.635-13.174 26.294l17.025.55c.88-1.302 2.837-20.299 3.629-20.959.991-.825 5.226-1.65 7.481-1.54 2.255.11 3.96-2.09 3.96-2.695s-1.32-.33-1.595-1.65z"
          fill="#9843EB"
        />
        <path
          d="M123.567 397.939c-1.047-.268 1.481-1.707 0-6.215"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="0.811"
        />
        <path
          d="M76.76 436.766l-6.944-13.893h58.78l-6.944 13.893H76.76z"
          fill="#944C1D"
        />
        <path
          clipRule="evenodd"
          d="M89.827 404.506v6.968h5.862v-6.968h7.035v6.968h5.862v-6.968h7.034v6.968h5.862v-6.968h7.114v18.373h-58.78v-18.373h7.115v6.969h5.862v-6.969h7.034z"
          fill="#D5815D"
          fillRule="evenodd"
        />
        <path
          d="M122.222 404.244c0-.867 5.584-10.938 8.376-15.865l1.901 1.451-8.372 13.898 1.447 1.612-1.447 1.48c.011-.263.026-.842 0-1.053-.026-.21-1.281-1.103-1.905-1.523z"
          fill="#F3898A"
        />
        <path
          d="M130.595 388.197l2.117 1.66"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="0.811"
        />
        <path
          d="M-2.371 466.685c0-7.894 6.399-14.293 14.293-14.293 7.893 0 14.292 6.399 14.292 14.293v22.235H-2.37v-22.235z"
          fill="#D4815D"
        />
        <path
          d="M.484 469.765a5.14 5.14 0 0110.278 0v18.902H.484v-18.902zm12.655 0a5.14 5.14 0 0110.278 0v18.902H13.139v-18.902z"
          fill="#4D0D54"
        />
        <path
          d="M-2.371 413.733c0-7.893 6.399-14.293 14.293-14.293 7.893 0 14.292 6.4 14.292 14.293v22.236H-2.37v-22.236z"
          fill="#D4815D"
        />
        <path
          d="M.484 416.813a5.14 5.14 0 0110.278 0v18.902H.484v-18.902zm12.655 0a5.14 5.14 0 0110.278 0v18.902H13.139v-18.902z"
          fill="#4D0D54"
        />
        <path
          d="M-53.195 434.09h91.876v9.732h-91.876zm24.303 91.596c0-11.949 9.686-21.634 21.635-21.634 11.948 0 21.634 9.685 21.634 21.634v28.981h-43.269v-28.981z"
          fill="#fff"
        />
        <path
          d="M-21.468 530.027c0-7.848 6.363-14.21 14.21-14.21 7.85 0 14.212 6.362 14.212 14.21v24.758h-28.422v-24.758z"
          fill={`url(#${id}-Z)`}
        />
        <path
          d="M52.284 505.713a4.88 4.88 0 019.758 0v17.947h-9.758v-17.947z"
          fill="#4D0D54"
        />
        <path d="M-53.195 487.701h91.876v9.732h-91.876z" fill="#fff" />
        <path
          d="M310.612 556.402c-206.121-13.065-710.942 9.415-819.805 19.33C241.964 598.96 143.281 756.178 16.032 808.116l414.737 49.656c195.658-15.181 415.087-267.444-120.157-301.37z"
          fill="#4E6EC0"
        />
        <ellipse
          cx="331.469"
          cy="740.822"
          fill={`url(#${id}-aa)`}
          rx="108.133"
          ry="6.585"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M232.524 623.555c.489-.399 11.127-16.977 16.385-25.216l6.054 9.775c-6.017 6.24-18.329 18.718-19.44 18.718-1.388 0-3.61-2.777-2.999-3.277z"
          fill="#4D0D54"
        />
        <path
          d="M242.466 601.616c4.621-.355 5.702 4.962 5.665 7.665.445 1.2 4.036.981 5.777.722-2.796 2.944-8.276 8.476-7.832 7.054.445-1.422.185-3.925 0-4.999-6.265 3.999-8.868.296-9.387-2.055 3.166.111 5.499-2.277 6.11-3.444.489-.933-.018-3.684-.333-4.943z"
          fill={`url(#${id}-ab)`}
        />
        <path
          d="M238.175 613.606c1.725.192 5.552 3.355 7.249 4.913l-10.964 9.826-3.954-3.355c1.837-3.875 5.943-11.576 7.669-11.384z"
          fill={`url(#${id}-ac)`}
        />
        <path
          d="M224.633 628.52c0-1.909 3.977-3.093 5.965-3.447l3.977 3.447c-.928 2.607-3.287 7.822-5.302 7.822-2.519 0-4.64-5.436-4.64-7.822z"
          fill={`url(#${id}-ad)`}
        />
        <path
          d="M221.264 623.102h4.219v20.509h-4.219z"
          fill={`url(#${id}-ae)`}
          transform="rotate(-37.023 221.264 623.102)"
        />
        <path
          d="M234.629 646.208l-2.82-12.326 11.077 6.099 2.82 12.326-11.077-6.099zm-74.531-106.507a.846.846 0 01.081-1.083.858.858 0 01.191-.148l.014-.008a.96.96 0 011.223.242l40.764 51.768a139.09 139.09 0 0031.259 29.097l-15.614 11.775a142.287 142.287 0 00-19.402-37.995l-38.516-53.648z"
          fill="#FFFBFB"
        />
        <path
          d="M231.409 655.633c6.936-19.116 16.283-16.987 20.089-13.534l-3.595 4.018c-8.289-2.199-10.996 19.666-2.326 31.085-.634 24.106-9.938 25.163-8.67 23.049 1.269-2.115-14.167-20.723-5.498-44.618z"
          fill="#4E1F0C"
        />
        <path
          d="M308.523 628.878l-9.797-9.894c-1.552 6.285 4.139 11.349 7.178 13.095l2.619-3.201z"
          fill="#7584D2"
        />
        <path
          d="M274.575 697.965c-1.005-4.451-5.443-21.954-7.537-30.149 1.97-3.016 22.689-1.476 17.581 14.728-4.086 12.963-4.756 33.289-4.579 41.831 1.902 2.888 1.732 6.957 1.409 8.63l3.591 6.415h-9.029c-.06-11.964-.431-37.005-1.436-41.455z"
          fill={`url(#${id}-af)`}
        />
        <path
          d="M274.575 697.965c-1.005-4.451-5.443-21.954-7.537-30.149 1.97-3.016 22.689-1.476 17.581 14.728-4.086 12.963-4.756 33.289-4.579 41.831 1.902 2.888 1.732 6.957 1.409 8.63l3.591 6.415h-9.029c-.06-11.964-.431-37.005-1.436-41.455z"
          fill={`url(#${id}-ag)`}
        />
        <path
          d="M233.27 582.441c-8.148 5.746-15.493 28.951-17.506 35.755a4.603 4.603 0 00.435 3.597l.261.458a4.294 4.294 0 006.316 1.3c.411-.311.444-1.008.386-1.52-.118-1.041.561-3.048 5.014-6.349 7.131-5.287 10.621 5.557 18.494-12.542 0 0 15.728 10.203 20.65 31.352-17.924 2.77-21.998 8.799-22.813 24.116-.814 15.316 2.844 23.627 5.347 34.707 2.002 8.864.834 19.229 0 28.069l-2.503 8.026.77 3.401-2.374 8.919h10.267l-2.759-8.406 1.155-3.144-.555-8.796c.848-12.42 4.995-19.692 8.543-32.207 2.552-8.999 3.077-16.404 9.881-15.45 16.265 2.279 14.562 16.593 14.845 27.669v36.123l-3.981 8.487h11.525v-14.25l-2.934-10.372v-19.988c0-21.773 4.75-22.118 7.125-24.334 6.622 5.113 8.138 15.176 8.068 24.334l6.181 29.732v7.944h11.735l-7.753-8.678c.838-4.945-1.746-9.814-3.143-11.63l-1.667-17.368c1.461-16.074 4.344-40.443 4.184-47.457-.159-7.014-8.701-20.06-12.952-25.705-20.245-44.636-60.662-52.548-70.242-45.793z"
          fill={`url(#${id}-ah)`}
        />
        <path
          d="M261.649 684.276l1.412-5.335h4.343l.614 12.007c.094 1.839-2.009 2.945-3.47 1.824a8.096 8.096 0 01-2.899-8.496z"
          fill="#7584D2"
        />
        <path
          d="M262.198 678.933c-1.203-1.023-.15-2.281.527-2.783.175-1.779.7-3.652 4.177-.423 4.272 3.966-3.2 4.484-4.704 3.206z"
          fill="#7584D2"
        />
        <path
          d="M257.111 662.196c-1.096-2.428-.457-6.408 0-8.094 2.663-1.282 8.125-3.427 8.673-1.754s1.04 5.104 1.217 6.61v18.214c-1.4.971-4.033.636-4.26 0-1.42-3.98-4.535-12.547-5.63-14.976z"
          fill={`url(#${id}-ai)`}
        />
        <path
          d="M258.83 577.884c-.218-.4.91-2.501 1.501-3.501.982-.4 1.682 1.803 1.909 2.955-1.045.349-3.191.946-3.41.546z"
          fill="#D9D9D9"
        />
        <path
          d="M288.669 575.793l-16.357-2.447-12.454 6.176c-.978.929-2.993 3.08-3.227 4.254-.235 1.173 21.379 6.074 39.895 34.907l3.993-1.803c0-14.323-4.122-29.495-11.85-41.087z"
          fill={`url(#${id}-aj)`}
        />
        <path
          clipRule="evenodd"
          d="M295.092 588.28l-4.092-.916-7.871 9.666-.657 4.223a94.161 94.161 0 017.423 8.205h10.263c-.655-6.779-2.193-13.577-4.562-19.942-.156-.42-.325-.832-.504-1.236z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M252.294 567.041l-.116-2.662h3.677l1.553 4.948h-1.812l-3.302-2.286z"
          fill="#6262B7"
        />
        <path
          d="M260.848 576.499c-3.327-4.135-5.149-9.526-5.644-11.704l9.447-4.219 5.526 9.091-1.664 5.109-7.665 1.723z"
          fill="#CE5E60"
        />
        <path
          clipRule="evenodd"
          d="M256.555 568.935c.952 2.366 2.372 5.175 4.294 7.564l7.665-1.723.593-1.823-1.598-2.63a6.56 6.56 0 00-8.28-2.582l-2.674 1.194z"
          fill="#F3898A"
          fillRule="evenodd"
        />
        <path
          d="M258.677 577.768c.784 0 9.029-5.924 13.053-8.886 1.165.49 2.061 3.423 1.265 5.261-.797 1.839-8.496 6.812-9.232 6.873-.588.049-3.636-2.145-5.086-3.248z"
          fill={`url(#${id}-ak)`}
        />
        <path
          d="M255.836 653.907V632.26l7.702-6.54 3.21 4.719.626 4.088-.93 19.38h-10.608z"
          fill={`url(#${id}-al)`}
        />
        <path
          d="M290.679 600.904c2.484-4.071 5.799-4.93 8.363-4.683 1.598.154 1.977 1.986 1.415 3.49-.658 1.763-.47 3.201.119 4.323.928 1.768 1.473 4.427.424 6.125-.132.214-.253.425-.363.633-1.112 2.102-4.514 5.119-6.788 4.424l-4.573-1.398c-.783-.239-1.425-.831-1.541-1.641-.325-2.289-.011-6.43 2.944-11.273z"
          fill="#7584D2"
        />
        <path
          clipRule="evenodd"
          d="M280.268 574.912c-2.957 1.306-6.175 3.891-6.499 8.364-.409 5.658-.241 8.701-.064 9.817.315.228.634.462.955.701l10.688 4.505 1.052-5.837 2.515 4.745c2.094-.25 6.462-1.548 7.187-4.745.238-1.049.122-2.695-.343-4.588-2.972-6.374-8.777-10.704-15.491-12.962z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M274.47 583.991c.46-6.354 6.762-8.9 9.856-9.378 9.151 1.88 13.384 14.567 12.478 18.564-.726 3.197-5.094 4.495-7.188 4.745l-2.515-4.745-1.052 5.837-11.579-4.88c-.191-.734-.459-3.79 0-10.143z"
          fill="#7584D2"
        />
        <path
          clipRule="evenodd"
          d="M292.03 579.613c.198.243.39.49.577.742-2.014.429-4.897 1.651-7.127 3.95-2.262 2.333-3.87 5.789-3.2 10.722a.426.426 0 11-.845.115c-.706-5.204.997-8.918 3.433-11.43 2.226-2.295 5.048-3.573 7.162-4.099zm-4.261-3.693c.341.194.673.404.996.628-2.012.435-4.878 1.657-7.097 3.945-2.262 2.332-3.87 5.788-3.2 10.721a.426.426 0 11-.845.115c-.707-5.204.997-8.918 3.433-11.43 2.071-2.136 4.66-3.391 6.713-3.979z"
          fill="#6262B7"
          fillRule="evenodd"
        />
        <path
          d="M269.177 572.785l-4.099-8.711 6.918-3.331c1.237 0 2.447.361 3.482 1.039l7.022 4.598-13.323 6.405z"
          fill={`url(#${id}-am)`}
        />
        <path
          clipRule="evenodd"
          d="M278.591 563.821l.814.533-11.363 6.02-.363-.772 10.912-5.781zm-2.862-1.874l.815.534-9.785 5.167-.363-.773 9.333-4.928z"
          fill="#6262B7"
          fillRule="evenodd"
        />
        <path
          d="M259.015 644.545l-4.155 5.464a2.624 2.624 0 00.192 3.401l4.151 4.342a2.624 2.624 0 003.757.038l4.323-4.347a2.624 2.624 0 00.198-3.478l-4.32-5.46a2.623 2.623 0 00-4.146.04z"
          fill="#7584D2"
        />
        <path
          d="M268.921 550.495c-3.033-2.255-7.173-1.11-8.864-.256l3.33 10.043 1.691 3.997 7.482-3.485c.051-2.493-.605-8.044-3.639-10.299z"
          fill={`url(#${id}-an)`}
        />
        <path
          d="M271.999 544.982c-1.726 1.121-3.667 3.631-4.422 4.745 0 .68.935.93 1.402.971 2.589-4.055 6.112-2.337 7.55-.971 0 4.745 2.265 11.971 7.657 11.648 5.393-.324.216-6.363 0-13.697-.173-5.867-5.177-5.033-7.657-3.883-2.041-3.434-5.711-1.259-4.53 1.187z"
          fill="#E6882B"
        />
        <path
          d="M234.143 581.622c-2.527-2.832-3.349-6.802-1.39-12.885 3.484 1.553 5.645 3.732 1.39 12.885z"
          fill="#9B5F2B"
        />
        <path
          d="M255.93 556.28l-3.85 8.251 8.958 1.964c.314-2.137 4.085-4.345 5.421-5.393l-1.021-4.193c1.571.419 4.808.88 5.186-.629.471-1.886-.943-2.357-4.165-2.75-3.221-.393-1.178-2.593-4.871-3.3-2.143-.41-3.809 1.138-4.812 2.65-.661.994-.846 2.206-.846 3.4z"
          fill={`url(#${id}-ao)`}
        />
        <path
          clipRule="evenodd"
          d="M256.067 554.689l7.335 1.842a.426.426 0 10.208-.827l-7.322-1.839a5.784 5.784 0 00-.221.824z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M265.501 627.462c.468 1.065.894 2.076 1.274 3.017l-2.313 2.786a6.195 6.195 0 01-8.529.966l-3.958-3.024 7.757-14.307c1.166 2.054 2.549 3.759 3.523 5.738l2.246 4.824z"
          fill={`url(#${id}-ap)`}
        />
        <path
          clipRule="evenodd"
          d="M239.973 593.988s-10.884-1.216-12.097-6.577c-.559-2.471.527-4.618 1.911-6.185 1.534-1.738 3.864-2.454 6.17-2.693 39.789-4.127 62.125 30.577 67.892 48.668-1.879.123-4.128.036-6.6-.278-.863-4.547-2.337-9.482-3.618-13.23a25.623 25.623 0 00-1.333-3.68c.386.997.846 2.252 1.333 3.68 1.246 4.426 1.419 9.101 1.181 12.859a57.16 57.16 0 01-7.903-2.003c-.219-2.318-1.007-4.606-1.55-5.796.61 2.04.636 3.971.469 5.427a56.154 56.154 0 01-3.449-1.345c-.468-4.722-1.359-11.309-2.073-16.23-.1-1.269-.25-2.351-.466-3.147.14.926.298 1.991.466 3.147.331 4.219.096 10.499-.206 15.188-2.735-1.331-5.381-2.921-7.791-4.784a446.622 446.622 0 00-4.104-21.441 23.703 23.703 0 00-.413-1.844c.116.506.255 1.125.413 1.844.798 4.316.833 10.199.315 18.061-2.35-2.432-4.302-5.218-5.651-8.381l-.945-2.217c-6.061-14.227-6.349-14.902-11.395-17.395-3.91-1.931-9.895-3.469-12.4-4.113-.21-.054-.395-.101-.553-.143-2.611 6.031 2.397 12.608 2.397 12.608z"
          fill="#FFFBFB"
          fillRule="evenodd"
        />
        <path
          d="M238.027 582.464c-1.548-3.466.743-9.471 4.457-14.671 2.848 2.538 2.066 12.189-4.457 14.671z"
          fill="#9B5F2B"
        />
        <path
          d="M226.206 613.86c35.414 29.584 56.495 3.353 62.621-13.524l-3.479-3.828c-12.431 25.401-38.659 32.619-57.791 15.848-.653-.572-1.71-.122-1.71.746 0 .289.137.572.359.758z"
          fill="#E6882B"
        />
        <path
          clipRule="evenodd"
          d="M253.336 733.1h-5.293l-2.297 8.631h10.267l-2.759-8.407.082-.224z"
          fill="#4E1F0C"
          fillRule="evenodd"
        />
        <path
          d="M281.548 732.361a9.232 9.232 0 01-.099.644l3.591 6.415h-9.029c-.01-2.031-.029-4.439-.059-7.059h5.596z"
          fill="#4E1F0C"
        />
        <path
          clipRule="evenodd"
          d="M294.669 736.399h-7.544v1.12l-3.981 8.487h11.525v-9.607z"
          fill="#4E1F0C"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M317.43 730.776h-4.395l.073.352v7.944h11.735l-7.413-8.296z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <ellipse
          cx="50.395"
          cy="601.576"
          fill={`url(#${id}-aq)`}
          rx="124.645"
          ry="18.862"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M29.166 560.028l12.045 30.63-9.98 18.585-70.897 2.753-23.059-13.422V571.73l36.137-18.585 55.754 6.883z"
          fill="#3D3271"
        />
        <path
          clipRule="evenodd"
          d="M29.15 560.026L17.808 581.71l-56.098 6.195-3.983 22.574-20.452-11.905V571.73l36.137-18.585 55.738 6.881z"
          fill={`url(#${id}-ar)`}
          fillRule="evenodd"
        />
        <path
          d="M39.635 713.042l24.437 62.141-20.248 37.704-143.833 5.585-46.78-27.23v-54.461l73.312-37.704 113.112 13.965z"
          fill="#413776"
        />
        <path
          clipRule="evenodd"
          d="M39.605 713.038l-23.011 43.991-113.81 12.568-8.082 45.797-41.492-24.152v-54.461l73.313-37.704 113.082 13.961z"
          fill={`url(#${id}-as)`}
          fillRule="evenodd"
        />
        <path
          d="M152.581 789.594c-62.704-92.847-162.15 22.03-101.754 62.48 273.295-41.076 514.673-41.847 715.449-43.879 21.607-9.877 21.992-65.128-9.576-81.001-31.569-15.873-51.034 9.26-66.057 22.224-4.938-12.346-27.575-8.848-38.275-5.556-15.538-64.261-80.873-44.543-80.873 0-10.865-14.322-27.574-5.967-34.57 0-3.457-22.224-26.134-22.43-37.041-19.755-35.37-101.944-146.818-47.935-130.26 14.817-10.371-15.31-36.276 4.938-28.396 19.137-21.73-16.298-44.86-6.791-53.708 0-7.324-82.746-120.487-49.312-87.661 20.372-21.73-2.963-40.573 6.206-47.278 11.161z"
          fill="#3FC7C0"
        />
        <path
          clipRule="evenodd"
          d="M303.674 803.941c-.146-33.279 34.757-48.217 67.519-7.764 5.609-13.463 23.237-11.649 31.351-9.059-.023-69.176 67.529-65.742 74.93-14.813 20.321-13.179 37.535-3.966 43.602 2.288 14.339-18.063 44.16-17.537 54.545 5.569 34.996-59.848 84.533-30.608 68.758 5.691 18.37-2.914 23.14 7.088 23.363 13.807-142.804 10.095-275.639 8.482-364.068 4.281zm372.984-4.926c7.836-1.758 14.233-2.148 19.419-1.505a2673.42 2673.42 0 01-19.419 1.505z"
          fill="#209F99"
          fillRule="evenodd"
        />
        <path d="M0 0h375v616H0V0z" fill={`url(#${id}-at)`} opacity="0.5" />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="1424.25"
          x2="1424.25"
          y1="26.885"
          y2="867.486"
        >
          <stop stopColor="#FF9877" />
          <stop offset="1" stopColor="#FFC6B5" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-g`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-h`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-i`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-j`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-k`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-l`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-m`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-n`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-o`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-p`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-q`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-r`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-s`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-t`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-u`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-v`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-w`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-x`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-y`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-z`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-A`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-B`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-C`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-D`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-E`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-F`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-G`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-H`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-I`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-J`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-K`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-L`}
          x1="773.546"
          x2="766.268"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-M`}
          x1="195.9"
          x2="195.9"
          y1="-2.268"
          y2="647.704"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-N`}
          x1="79.184"
          x2="-6.318"
          y1="527.984"
          y2="413.804"
        >
          <stop stopColor="#E895FF" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-O`}
          x1="79.184"
          x2="-6.318"
          y1="527.984"
          y2="413.804"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-R`}
          x1="2.277"
          x2="-3.12"
          y1="464.38"
          y2="388.442"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-S`}
          x1="105.323"
          x2="-8.831"
          y1="662.014"
          y2="389.655"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-T`}
          x1="159.203"
          x2="34.413"
          y1="645.448"
          y2="457.527"
        >
          <stop stopColor="#E895FF" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-U`}
          x1="159.203"
          x2="34.413"
          y1="645.448"
          y2="457.527"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-X`}
          x1="128.609"
          x2="127.571"
          y1="393.133"
          y2="406.626"
        >
          <stop stopColor="#CE5E60" />
          <stop offset="1" stopColor="#F3898A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Y`}
          x1="131.769"
          x2="131.769"
          y1="217.089"
          y2="623.125"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Z`}
          x1="-25.231"
          x2="-7.257"
          y1="494.224"
          y2="554.785"
        >
          <stop stopColor="#89233E" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aa`}
          x1="487.968"
          x2="-176.515"
          y1="767.093"
          y2="679.532"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ab`}
          x1="245.299"
          x2="245.299"
          y1="601.599"
          y2="617.287"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ac`}
          x1="237.965"
          x2="237.965"
          y1="613.602"
          y2="628.345"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ad`}
          x1="229.604"
          x2="229.604"
          y1="625.073"
          y2="636.342"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ae`}
          x1="223.373"
          x2="223.373"
          y1="623.102"
          y2="643.612"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-af`}
          x1="279.573"
          x2="227.416"
          y1="640.018"
          y2="679.601"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#872A81" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ag`}
          x1="276.232"
          x2="242.717"
          y1="657.251"
          y2="686.634"
        >
          <stop stopColor="#56180E" />
          <stop offset="1" stopColor="#87572A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ah`}
          x1="270.032"
          x2="213.781"
          y1="559.145"
          y2="688.425"
        >
          <stop stopColor="#893729" />
          <stop offset="1" stopColor="#87572A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ai`}
          x1="261.754"
          x2="261.754"
          y1="651.735"
          y2="677.781"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aj`}
          x1="278.574"
          x2="278.574"
          y1="573.346"
          y2="632.252"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ak`}
          x1="265.987"
          x2="265.987"
          y1="568.882"
          y2="581.017"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-al`}
          x1="261.605"
          x2="261.605"
          y1="625.72"
          y2="653.907"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-am`}
          x1="273.789"
          x2="273.789"
          y1="560.743"
          y2="576.389"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-an`}
          x1="266.309"
          x2="266.309"
          y1="549.178"
          y2="564.279"
        >
          <stop stopColor="#7878D1" />
          <stop offset="1" stopColor="#5252A6" stopOpacity="0.99" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ao`}
          x1="261.396"
          x2="261.396"
          y1="550.163"
          y2="571.383"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ap`}
          x1="259.375"
          x2="259.375"
          y1="616.9"
          y2="641.072"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aq`}
          x1="230.79"
          x2="-546.272"
          y1="676.824"
          y2="635.614"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ar`}
          x1="-16.787"
          x2="-16.787"
          y1="553.145"
          y2="610.479"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-as`}
          x1="-53.593"
          x2="-53.593"
          y1="699.077"
          y2="815.394"
        >
          <stop stopColor="#A2ADFF" />
          <stop offset="1" stopColor="#5E7DCB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-at`}
          x1="187.5"
          x2="187.5"
          y1="187.22"
          y2="616"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(7.4477 30.84941 -22.74252 5.49053 36.699 344.681)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-P`}
          r="1"
        >
          <stop stopColor="#75337C" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(7.4477 30.84941 -22.74252 5.49053 36.699 344.681)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-Q`}
          r="1"
        >
          <stop stopColor="#7C334F" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(13.77108 30.59061 -37.00356 16.65801 85.364 383.103)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-V`}
          r="1"
        >
          <stop stopColor="#75337C" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(13.77108 30.59061 -37.00356 16.65801 85.364 383.103)"
          gradientUnits="userSpaceOnUse"
          id={`${id}-W`}
          r="1"
        >
          <stop stopColor="#7C334F" />
          <stop offset="1" stopColor="#4D0D54" />
        </radialGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2750.87"
          id={`${id}-c`}
          width="2746.77"
          x="-1773.04"
          y="-1069.63"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_30229"
            stdDeviation="392.625"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2978.22"
          id={`${id}-d`}
          width="3012.83"
          x="-709.523"
          y="-1068.65"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_30229"
            stdDeviation="400"
          />
        </filter>
        <clipPath id={`${id}-a`}>
          <path d="M0 0h375v812H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
